export const typeToI18nMap = {
    vacation: 'absence_type_vacation',
    selfCertifiedSick: 'absence_type_selfCertifiedSick',
    sick: 'absence_type_sick',
    paidTimeOff: 'absence_type_paidTimeOff',
    unpaidTimeOff: 'absence_type_unpaidTimeOff',
    sickChild: 'absence_type_sickChild',
    parentalLeave: 'absence_type_parentalLeave'
}